<script>
import Popin from "@/components/molecules/popin";
import Button from "@/components/atoms/button";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import LazyImage from "@/components/atoms/lazy-image";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Container from "@/components/atoms/container";
import Divider from "@/components/atoms/divider";
import ButtonGroup from "@/components/molecules/button-group";
import StickyFooter from "@/components/molecules/sticky-footer";

export default {
  name: "PopinPanierRecupere",
  components: {
    Popin,
    Button,
    Icon,
    Badge,
    List,
    ListItem,
    LazyImage,
    GridRow,
    GridCol,
    Container,
    Divider,
    ButtonGroup,
    StickyFooter
  },
  props: {
    dateLastUpdate: {
      type: String,
      required: false,
      default: "mardi 24 mars à 09h18"
    },
    pageBack: {
      type: Boolean,
      required: false,
      default: false
    },
    status: {
      type: String,
      required: false,
      default: "recupere" // ou complete
    },
    indisponibles: {
      type: Array,
      required: false,
      // TODO : supprimer la valeur par défaut en dev
      default() {
        return [
          {
            visuel:
              "https://www.coradrive.fr/media/produit/1580806809/280/R20/iZzbJwILlrhxwriZwrQBILhxlrOqQB.jpg",
            description:
              "Cora pur jus d'orange 1l Cora pur jus d'orange 1l Cora pur jus d'orange 1l Cora pur jus d'orange 1l"
          },
          {
            visuel:
              "https://www.coradrive.fr/media/produit/1580806809/280/R20/iZzbJwILlrhxwriZwrQBILhxlrOqQB.jpg",
            description: "Cora pur jus d'orange 1l"
          },
          {
            visuel:
              "https://www.coradrive.fr/media/produit/1580806809/280/R20/iZzbJwILlrhxwriZwrQBILhxlrOqQB.jpg",
            description: "Cora pur jus d'orange 1l"
          }
        ];
      }
    },
    produits: {
      type: Array,
      required: false,
      // TODO : supprimer la valeur par défaut en dev
      default() {
        return [
          {
            visuel:
              "https://www.coradrive.fr/media/produit/1580806809/280/R20/iZzbJwILlrhxwriZwrQBILhxlrOqQB.jpg",
            description:
              "Cora pur jus d'orange 1l Cora pur jus d'orange 1l Cora pur jus d'orange 1l Cora pur jus d'orange 1l"
          },
          {
            visuel:
              "https://www.coradrive.fr/media/produit/1580806809/280/R20/iZzbJwILlrhxwriZwrQBILhxlrOqQB.jpg",
            description: "Cora pur jus d'orange 1l"
          },
          {
            visuel:
              "https://www.coradrive.fr/media/produit/1580806809/280/R20/iZzbJwILlrhxwriZwrQBILhxlrOqQB.jpg",
            description: "Cora pur jus d'orange 1l"
          }
        ];
      }
    }
  },
  emits: ["complete", "showSimilaires"],
  computed: {
    isRecupere() {
      return this.status === "recupere";
    },
    produitsToShow() {
      return this.isRecupere ? this.indisponibles : this.produits;
    }
  },
  methods: {
    complete() {
      this.$refs.popin.hide();
      this.$emit("complete");
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    :page-back="pageBack"
    aria-label="Panier récupéré"
    size="lg"
    class="c-popin-panier-recupere"
  >
    <div class="u-text-center ">
      <Badge
        variant="secondary"
        class="u-mb-sm"
        circle
        size="xlg"
      >
        <Icon
          name="basket"
          variant="white"
          size="xlg"
        />
      </Badge>
      <p :class="pageBack && 'u-ml-md@md u-mr-md@md'">
        <template v-if="isRecupere">
          Les produits présents dans votre panier le {{ dateLastUpdate }} ont été rechargés.
        </template>
        <template v-else>
          Lors de votre visite du {{ dateLastUpdate }}, vous aviez commencé un panier de {{ produits.length }} produits.
        </template>
      </p>
      <div class="u-mt-md">
        <template v-if="produitsToShow">
          <div :class="pageBack && 'u-ml-md@md u-mr-md@md'">
            <Divider dotted />
            <h1 class="u-font-secondary u-color-primary u-font-24 u-font-700 u-mt-md u-mb-md">
              <template v-if="isRecupere">
                <template v-if="produitsToShow.length === 1">
                  Ce produit a été supprimé car il n'est plus disponible
                </template>
                <template v-else>
                  Ces produits ont été supprimés car ils ne sont plus disponibles
                </template>
              </template>
              <template v-else>
                <template v-if="produitsToShow.length === 1">
                  Souhaitez-vous compléter le panier en cours avec le produit suivant ?
                </template>
                <template v-else>
                  Souhaitez-vous compléter le panier en cours avec les produits suivants ?
                </template>
              </template>
            </h1>
          </div>
          <div
            class="u-mb-xlg"
            :class="pageBack && 'u-ml-md@md u-mr-md@md'"
          >
            <List
              class="c-popin-panier-recupere__produits"
              :class="[!pageBack && 'c-popin-panier-recupere__produits--scrollable', pageBack && 'u-ml-md@md u-mr-md@md']"
            >
              <!-- TODO : fixer la key en dev -->
              <ListItem
                v-for="(produit, index) in produitsToShow"
                :key="index"
                :class="(index < produitsToShow.length - 1) && 'c-popin-panier-recupere__produits-list--border'"
                class="u-mb-sm u-pb-sm"
              >
                <GridRow class="u-flex-align-center">
                  <GridCol
                    cols="8"
                    md="12"
                    class="u-flex u-flex-align-center"
                  >
                    <LazyImage
                      :src="produit.visuel"
                      :dimension="96"
                      width="50"
                      height="50"
                      class="u-mr-md u-flex-shrink-none"
                    />
                    <p class="u-mr-md u-text-left">
                      {{ produit.description }}
                    </p>
                  </GridCol>
                  <GridCol
                    cols="4"
                    md="12"
                    class="u-text-right@md u-mt-sm@md"
                  >
                    <Button
                      radius="full"
                      variant="primary"
                      size="sm"
                      @click="$emit('showSimilaires')"
                    >
                      Voir les produits similaires
                    </Button>
                  </GridCol>
                </GridRow>
              </ListItem>
            </List>
          </div>
          <component
            :is="pageBack ? 'StickyFooter' : 'div'"
            :in-dom="false"
          >
            <component
              :is="isRecupere ? 'div' : 'ButtonGroup'"
              :class="!pageBack && 'u-pl-xxlg u-pl-none@md u-pr-xxlg u-pr-none@md'"
            >
              <Button
                outline
                variant="primary"
                size="md"
                radius="full"
                class="u-mt-xs"
                @click="$refs.popin.hide()"
              >
                Ignorer
              </Button>
              <Button
                v-if="!isRecupere"
                variant="secondary"
                size="md"
                radius="full"
                class="u-mt-xs"
                @click="complete()"
              >
                Compléter mon panier
              </Button>
            </component>
          </component>
        </template>
        <Button
          v-else
          variant="primary"
          link
          @click="$refs.popin.hide()"
        >
          Ok j'ai compris !
        </Button>
      </div>
    </div>
  </Popin>
</template>

<style lang="scss" scoped>
.c-popin-panier-recupere__produits--scrollable {
  max-height: 200px;
  overflow-y: auto;
}
.c-popin-panier-recupere__produits-list--border {
  border-bottom: 2px solid color(grey-6);
}
</style>
